export const fileUploadOptions = [{
  key: 'FILE',
  value: '.doc,.docx,.odt,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.oasis.opendocument.text',
  label: 'Documents'
}, {
  key: 'TXT',
  value: '.xls,.xlsx,.ods,.csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.oasis.opendocument.spreadsheet,text/csv',
  label: 'Spreadsheets'
}, {
  key: 'PDF',
  value: '.pdf,application/pdf',
  label: 'PDF'
}, {
  key: 'VID',
  value: '.mp4,.ogg,.webm,video/mp4,video/ogg,video/webm',
  label: 'Videos'
}, {
  key: 'IMG',
  value: '.png,.jpeg,.jpg,.gif,.webp,image/png,image/jpeg,image/gif,image/webp',
  label: 'Images'
}, {
  key: 'AUD',
  value: '.mp3,.ogg,.wav,audio/mpeg,audio/ogg,audio/wav',
  label: 'Audio'
}];
export const getFileType = file => {
  const mimeType = file?.type;
  const extension = file?.name?.split('.').pop().toLowerCase();
  const fileType = fileUploadOptions.find(option => option.value.includes(mimeType) || option.value.includes(extension));
  return fileType ? fileType.key : 'unknown';
};
export const getFileTypeFromUrl = url => {
  if (!url) {
    return 'BROKEN';
  }
  const urlWithoutParams = url.split('?')[0];
  const extension = urlWithoutParams.split('.').pop().toLowerCase();
  const fileType = fileUploadOptions.find(option => option.value.includes(extension));
  return fileType ? fileType.key : 'UNKNOWN';
};